/*
 * The rendered markdown body's copy: what a body draws in place of something it will not draw (an
 * unknown node, a refused image, a cut-off tree), the names its regions carry, the code block's
 * chrome, and the words around a text file the page draws as text. Every module that shows markdown
 * — a chat message, an AI chat's prose — or a text file's preview speaks with these; a module's own
 * tokens (chat's `@channel`, `#slug`) keep their words in that module's catalogue.
 */

export const en = {
	"render.unknownNode": "[unknown content]",
	"render.truncated": "This message is too long and is shown shortened.",
	"render.image": "Image: {name}",
	"render.table": "Table",
	"render.permalink": "Message {seq}",
	"render.mentionGroup": "Group @{handle}: {members}",

	"render.code.copy": "Copy code",
	"render.code.copied": "Code copied.",
	"render.code.copyFailed": "Your browser did not allow copying.",
	"render.code.expand": "Show {count} lines",
	"render.code.expand.one": "Show {count} line",
	"render.code.collapse": "Show less",
	"render.code.plain": "Text",
	// The block is a named scroll region, the treatment a table has (X-B3 D4); the status region is
	// named too, because an unnamed region in the region list says nothing about what it will speak.
	"render.code.region": "Code",
	"render.code.regionLang": "Code, {lang}",
	"render.code.status": "Code block",

	// A text file the page draws itself (FileText.tsx): the drive's file page and a chat
	// attachment's preview. The region is named after the file, as a code block's after its language.
	"render.file.region": "Text of {name}",
	"render.file.failed": "The preview could not be loaded.",
	"render.file.partial": "Showing the first {count} lines. Download the file for the rest.",
	"render.file.partial.one": "Showing the first line. Download the file for the rest.",
} as const satisfies Record<string, string>
